import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGetDiagnosisMutation } from "../store/General/generalSlice";
import "../styles/quickddx.css";

const crossicon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/lounge/crossicon.svg";

export default function SymptomChecker({
  isVisible,
  onClose,
  finalstage,
  setsymptomcheckerLoading,
  initialValues = [],
}) {
  const [
    getDiagnosis,
    { data: diagnosisData, isLoading: diagnosisLoading, error },
  ] = useGetDiagnosisMutation();
  const [inputFields, setInputFields] = useState([...initialValues]);
  const navigate = useNavigate();

  // Only update the input fields if initialValues change
  useEffect(() => {
    if (JSON.stringify(initialValues) !== JSON.stringify(inputFields)) {
      setInputFields([...initialValues]);
    }
  }, [initialValues]);

  const addInputField = (e) => {
    e.preventDefault();
    if (inputFields.length < 8) {
      setInputFields((prevFields) => [...prevFields, ""]);
    }
  };

  const handleInputChange = (index, value) => {
    const newFields = [...inputFields];
    newFields[index] = value;
    setInputFields(newFields);
    console.log("Input Fields:", inputFields);
  };

  const handleRemoveField = (index) => {
    const newFields = inputFields.filter((_, i) => i !== index);
    setInputFields(newFields);
  };

  const handleSubmit = async (e) => {
    console.log("Submitting symptom checker form");
    e.preventDefault();
    e.stopPropagation(); // Ensure the form does not refresh the page

    try {
      // Filter out empty or invalid inputs
      const validQueries = inputFields.filter(
        (query) => query && query.trim() !== ""
      );
      if (validQueries.length === 0) {
        console.error("No valid queries to submit.");
        return; // Exit if no valid queries
      }

      const queries = validQueries.join(",");
      const formData = new FormData();
      formData.append("quick_query", queries);
      formData.append("type", "SYMPTOMCHECKER");

      console.log("Submitting with queries:", queries);
      onClose();
      setsymptomcheckerLoading(true);

      const response = await getDiagnosis(formData).unwrap();

      console.log("Diagnosis Response:", response);
      if (response) {
        navigate("/diagnose", {
          state: {
            diagnosisResult: response,
            type: "SYMPTOM",
            queries: queries,
          },
        });
      } else {
        console.error("No response from diagnosis API.");
      }
    } catch (error) {
      console.error(
        "Error during diagnosis submission:",
        error.message || error
      );
    }
  };

  if (!isVisible) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div
        className="symptomchecker-popup"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="symptomcheckerclose">
          <img
            src={crossicon}
            alt="Close"
            onClick={onClose}
            className="closeicon"
          />
        </div>
        <div className="symptomchecker">
          <div className="researchelementleft">
            <form onSubmit={handleSubmit}>
              {inputFields.map((field, index) => (
                <div key={index} className="input-with-cross">
                  <input
                    type="text"
                    placeholder="Enter Here"
                    value={field}
                    onChange={(e) => handleInputChange(index, e.target.value)}
                  />
                  {index >= initialValues.length && (
                    <img
                      src={crossicon}
                      alt="Remove"
                      className="cross-icon"
                      onClick={() => handleRemoveField(index)}
                    />
                  )}
                </div>
              ))}

              {inputFields.length < 8 && (
                <button
                  className="elementselectorlightblue addmorebutton w-full"
                  onClick={addInputField}
                >
                  Add More
                </button>
              )}

              <button onClick={handleSubmit} className="generatebutton">
                Search Diseases
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
